import { useRef, useEffect } from 'react';

import _ from 'lodash';

import moment from 'moment';

import { commonInput } from './formsComponents/formTypes';
import { FormatSendDate } from '../../utils/helpers/date_helpers';

const collectAllFields = (fields) => {
  //
  const formFields: any[] = [];
  const fieldsDependencies = {};
  const layoutFields: any = { rows: [] };

  let hasSubmitButton = false;
  // ha oggetti righe e colonne
  if (fields[0] && _.isArray(fields[0])) {
    _.each(fields, (row) => {
      _.each(row, (col: any) => {
        layoutFields.rows.push(col);

        _.each(col.items, (field) => {
          if (!field || !field.type) {
            return;
          }
          if (
            field.element &&
            field.element === 'button' &&
            field.action &&
            field.action === 'submit'
          ) {
            hasSubmitButton = true;
          }

          formFields.push(field);

          if (field.influence) {
            fieldsDependencies[field.name] = field.influence;
          }
        });
      });
    });
  } else {
    // Niente righe e colonne
    layoutFields.rows.push({ items: [...fields] });
    _.each(fields, (field) => {
      if (
        field.element &&
        field.element === 'button' &&
        field.action &&
        field.action === 'submit'
      ) {
        hasSubmitButton = true;
      }

      if (!field.type) {
        return;
      }
      formFields.push(field);

      if (field.influence) {
        fieldsDependencies[field.name] = field.influence;
      }
    });
  }

  return {
    formFields,
    fieldsDependencies,
    layoutFields,
    hasSubmitButton,
  };
};

interface formatSubmitPayloadProps {
  values: any;
  excludedFields?: string[];
  stripEmpty?: boolean;
  fields?: any[];
}

export const formatSubmitPayload = ({
  values,
  excludedFields = ['patient', 'hospitalization', 'patientOrHosp'],
  stripEmpty = false,
  fields = [],
}: formatSubmitPayloadProps) => {

  const formattedPayload = _.cloneDeep(values);

  let formattedData;
  _.each(values, (data, key) => {
    let currentField: commonInput = fields?.length ? _.find(fields, { name: key }) : null;
    if (!currentField) {
      const flatten = flattenFields(fields, 'fields');
      currentField = _.find(flatten, { name: key });
    }
    formattedData = formatPayloadData(data, currentField);
    if (!formattedData) {
      if (_.isArray(data)) {
        _.forEach(data, (subdata, subkey) => {
          _.forEach(subdata, (subSubdata, subsubkey) => {
            formattedData = formatPayloadData(subSubdata, currentField);
            if (stripEmpty && !formattedData) delete formattedPayload[key][subkey][subsubkey];
            else formattedPayload[key][subkey][subsubkey] = formattedData;
          });
        });
      } else if (_.isObjectLike(data)) {
        //debugger;
        _.forEach(data, (subdata, subkey) => {
          //debugger;

          if (excludedFields.length && excludedFields.includes(subkey)) {
            formattedData = subdata;
          } else if (_.isObjectLike(subdata)) {
            formattedData = formatObjectData(subdata);
          } else {
            formattedData = subdata;
          }
          if (stripEmpty && !formattedData) delete formattedPayload[key][subkey];
          else formattedPayload[key][subkey] = formattedData;
        });
      }
    } else if (stripEmpty && !formattedData) delete formattedPayload[key];
    else formattedPayload[key] = formattedData;
  });

  if (stripEmpty) return removeEmptyValues(formattedPayload);
  return formattedPayload;
};

export const formatObjectData = (objectData) => {
  //debugger;
  if (isSelectObjectData(objectData)) {
    return isSelectObjectData(objectData);
  }
  const cleanedObject = _.mapValues(objectData, (subdata, subkey) => {
    const formattedData = formatPayloadData(subdata);
    //debugger;
    return formattedData || formatObjectData(subdata);
  });
  //debugger;
  return cleanedObject;
};

export const formatPayloadData = (data, currentField: commonInput | undefined = undefined) => {
  // if (!data) { return null; }
  if (
    moment.isMoment(data) ||
    moment.isDate(data) ||
    moment.isMoment(data?.[0]) ||
    moment.isDate(data?.[0])
  ) {
    // @ts-ignore
    if (currentField?.type === 'time') {
      data = FormatSendDate(data?.[0] || data, 'HH:mm');
    }
    // è un ORARIO TIME
    else if (_.isArray(data)) {
      data = data.map((dat) => FormatSendDate(dat));
    } else {
      data = FormatSendDate(data);
    }
  }
  // SELECT && RADIO
  else if (isSelectObjectData(data)) {
    //debugger;
    data = isSelectObjectData(data);
  }
  // CHECKBOX ARRAYS
  else if (_.isArray(data) && _.every(data, (val) => !_.isObject(val))) {
    data = data;
  }
  // ALTRO DA RICICLARE
  else if (_.isObject(data)) {
    data = false;
  }

  return data;
};

const isSelectObjectData = (data) => {
  let isSelectValue = false;
  if (data?.value ?? data?.key ?? data?.label ?? data?.name) {
    isSelectValue = data?.value ?? data?.key ?? data;
  }
  return isSelectValue;
};
const flattenFields = (items, key) =>
  items.reduce((flattenedItems, item) => {
    flattenedItems.push(item);
    if (Array.isArray(item[key])) {
      flattenedItems = flattenedItems.concat(flattenFields(item[key], key));
    }
    return flattenedItems;
  }, []);

export const usePrevious = (value) => {
  const ref = useRef(null);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export const removeEmptyValues = (values: any) =>
  _.pickBy(values, (v) => {
    if (_.isObjectLike(v)) {
      return removeEmptyValues(v);
    }
    return v;
  });

export const removeEmptyVal = (values: any = {}) =>
  _.pickBy(values, (v) => v !== null && v !== undefined);

export const isPromise = (theFunction: any) => {
  if (theFunction?.constructor?.name === 'AsyncFunction') return true;
  if (theFunction instanceof Promise) return true;
  return false;
};
